import React from 'react';
import SolidButton from '@wix/da-ds/pkg/Buttons/SolidButton/SolidButton';
import { useTranslation } from 'react-i18next';
import { useEditDeviationAction } from '../../../actionHooks/useEditDeviationAction';
const EditButton = ({ deviation })=>{
    const { t } = useTranslation();
    const onClick = useEditDeviationAction(deviation);
    return /*#__PURE__*/ React.createElement(SolidButton, {
        variant: "main",
        size: "medium",
        onClick: onClick
    }, t('actionbar.stash.editDraft'));
};
EditButton.displayName = 'EditButton';
export default EditButton;
